export default function useFormElementId(
  id?: string | null,
  name?: string | null,
  label?: string | null
) {
  return id ?? name ?? label ?? ''
}
